<template>
  <div id="MasterUser">
    <BaseTitle :title="$t('content.user_list')" />
    <v-card class="mb-7">
      <div class="pa-5">
        <h3>{{ $t('filter') }}</h3>
        <v-row>
          <v-col cols="12" md="6">
            <v-select :items="status" :label="$t('form.status')" v-model="form.status" clearable @change="getData">
              <template #item="{item}">
                {{ $t(item.text) }}
              </template>
              <template #selection="{item}">
                {{ $t(item.text) }}
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              :items="roleWithoutSchooladmin"
              item-value="roleId"
              item-text="roleName"
              :label="$t('table.role')"
              v-model="form.role"
              clearable
              @change="getData"
            >
              <template #item="{item}">
                <span v-if="item.roleName == 'Master Administrator'">{{ $t('roles.master_administrator') }}</span>
                <span v-else-if="item.roleName == 'School Administrator'">{{ $t('roles.school_administrator') }}</span>
                <span v-else>{{ item.roleName }}</span>
              </template>
              <template #selection="{item}">
                <span v-if="item.roleName == 'Master Administrator'">{{ $t('roles.master_administrator') }}</span>
                <span v-else-if="item.roleName == 'School Administrator'">{{ $t('roles.school_administrator') }}</span>
                <span v-else>{{ item.roleName }}</span>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-card>
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">{{ $t('content.user_list') }}</div>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div>
              <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="goToCreate">{{ $t('add') }}</v-btn>
            </div>

            <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
            <div>
              <v-text-field v-model="search" :label="$t('search')" @change="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <div v-for="item in listData" :key="item.userId" class="border-item">
          <v-row class="border-item">
            <v-col md="1" align="center">
              <div class="mt-5 ml-5">
                <svg-icon icon="customer-plus" width="30" height="30" class="primary--text" />
                <v-divider vertical></v-divider>
              </div>
            </v-col>
            <v-col md="10" class="mt-3">
              <div class="d-block">
                <h3 class="d-inline">
                  <span class="header-content">{{ item.fullName }} </span>
                </h3>
              </div>
              <div class="d-block">
                <div>
                  <span class="mr-3">
                    {{ $t('form.status') }}:
                    <strong v-if="item.status" class="green--text font-italic header-content">{{ $t('form.active') }}</strong>
                    <strong v-else class="red--text font-italic header-content">{{ $t('form.noactive') }}</strong>
                  </span>
                  |
                  <span class="body-content">
                    <span class="mr-3">
                      {{ $t('table.role') }}:
                      <strong>{{ item.roleName }}</strong>
                    </span>
                  </span>
                </div>
              </div>
              <div class="d-flex"></div>
            </v-col>
            <v-col md="1">
              <template>
                <div class="pa-5">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <span dark v-bind="attrs" v-on="on">
                        <svg-icon icon="ic-moreaction-black" class="mt-1" />
                      </span>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-list-item-title class="text-dropdown" @click="viewItem(item)">{{ $t('view') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title class="text-dropdown" @click="editItem(item)">{{ $t('edit') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="!item.primarySchoolAdmin && !item.primaryMasterAdmin && item.userId !== currentUser.userId">
                        <v-list-item-title class="text-dropdown-delete" @click="onDeleteItem(item)">{{ $t('table.delete') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title class="text-dropdown" @click="onGenerateItem(item)">{{ $t('table.generate_password') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
            </v-col>
          </v-row>
        </div>
        <NoData v-if="!listData.length" />
        <!-- <v-data-table
          :headers="tableHeader"
          :items="items"
          :loading="table.loading"
          :server-items-length="items.length"
          :options.sync="table.options"
          hide-default-footer
          class="table-custom"
        >
          <template #top>
            <table-header @fetch="getData">
              <template slot="left">
                <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="goToCreate">{{ $t('add') }}</v-btn>
              </template></table-header
            >
          </template>
          <template #item.generatepassword="{ item }">
            <v-btn color="primary" @click="onGenerateItem(item)" class="btn-primary-custom mb-2 mb-md-0 mr-md-2">{{ $t('form.generate') }}</v-btn>
          </template>

          <template #item.roleName="{ item }">
            <span v-if="item.roleName == 'Master Administrator'">{{ $t('roles.master_administrator') }}</span>
            <span v-if="item.roleName == 'School Administrator'">{{ $t('roles.school_administrator') }}</span>
          </template>

          <template #item.status="{ item }">
            <strong v-if="item.status" class="green--text font-italic">{{ $t('form.active') }}</strong>
            <strong v-else class="red--text font-italic">{{ $t('form.noactive') }}</strong>
          </template>

          <template #item.actions="{ item }">
            <v-btn
              v-if="!item.primarySchoolAdmin && !item.primaryMasterAdmin && item.userId !== currentUser.userId"
              text
              @click="onDeleteItem(item)"
              class="mr-1 btn-action-custom"
            >
              <svg-icon icon="delete" class="red--text" />
            </v-btn>
            <v-btn text @click="viewItem(item)" class="mr-1 btn-action-custom"><svg-icon icon="view" class="primary--text"/></v-btn>
            <v-btn text @click="editItem(item)" class="btn-action-custom"><svg-icon icon="edit" class="primary--text"/></v-btn>
          </template>

          <template #no-data>
            <NoData />
          </template>
          <template #loading>
            <img src="@/assets/images/globe.gif" class="pa-4" />
          </template>
        </v-data-table>
        <table-footer @fetch="getData" /> -->
      </div>
    </v-card>

    <!-- Dialog Generate -->
    <v-dialog v-model="dialogGenerate" persistent max-width="340">
      <v-card>
        <v-card-title class="headline">{{ $t('generate_title') }}</v-card-title>
        <v-card-text>{{ $t('generate_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :loading="table.loading" @click="dialogGenerate = false">{{ $t('disagree') }}</v-btn>
          <v-btn text @click="generatePasswordItem">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Delete -->
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
        <v-card-text>{{ $t('delete_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
          <v-btn text :loading="table.loading" @click="deleteItem">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
// import SvgIcon from '@/components/SvgIcon';
// import TableHeader from '@/components/table/TableHeader';
// import TableFooter from '@/components/table/TableFooter';
import NoData from '@/components/table/NoData';

export default {
  name: 'MasterUser',
  components: {
    BaseTitle,
    // SvgIcon
    // TableHeader,
    // TableFooter,
    NoData
  },
  computed: {
    ...mapGetters({
      currentUser: 'Auth/user',
      items: 'User/items',
      status: 'Reference/itemStatus',
      role: 'Role/items'
    }),
    roleWithoutSchooladmin() {
      return this.role.filter(role => role.roleId !== 3 && role.roleId !== 4 && role.roleId !== 5);
    },
    tableHeader() {
      return [
        { text: this.$t('table.name'), value: 'fullName' },
        { text: this.$t('table.role'), value: 'roleName' },
        { text: 'Status', value: 'status' },
        { text: this.$t('table.generate_password'), value: 'generatepassword', sortable: false },
        { text: this.$t('table.action'), value: 'actions', sortable: false, width: 200 }
      ];
    }
  },
  data: () => ({
    dialogGenerate: false,
    generatePwItem: null,
    dialogDelete: false,
    currentItem: null,
    listData: [],
    search: '',
    loadingLoad: false,
    form: {
      status: '',
      role: ''
    },
    table: {
      loading: false,
      options: {}
    }
  }),
  watch: {
    'table.options': function() {
      this.getData();
    }
  },
  methods: {
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('User/fetchList', {
          search: this.search,
          status: this.form.status,
          roleId: this.form.role
        })
        .then(data => (this.listData = data))
        .finally(() => (this.loadingLoad = false));
    },
    editItem({ userId, roleName }) {
      if (roleName === 'Master Administrator') {
        this.$router.push({ name: 'MasterUserEdit', params: { id: userId } });
      } else {
        this.$store.dispatch('User/fetchDetail', userId).then(data => {
          this.$router.push({ name: 'SchoolEdit', params: { id: data.schoolId } });
        });
      }
    },
    viewItem({ userId, roleName }) {
      if (roleName === 'Master Administrator') {
        this.$router.push({ name: 'MasterUserDetail', params: { id: userId } });
      } else {
        this.$store.dispatch('User/fetchDetail', userId).then(data => {
          this.$router.push({ name: 'SchoolDetail', params: { id: data.schoolId } });
        });
      }
    },
    onDeleteItem(item) {
      this.dialogDelete = true;
      this.currentItem = item;
    },
    deleteItem() {
      if (!this.currentItem) return false;

      this.table.loading = true;
      this.$store
        .dispatch('User/destroy', this.currentItem)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.currentItem = null;
          this.getData();
          this.dialogDelete = false;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.table.loading = false));
    },
    getRole() {
      this.$store.dispatch('Role/fetchList');
    },
    onGenerateItem(item) {
      this.generatePwItem = item;
      this.dialogGenerate = true;
    },
    generatePasswordItem() {
      if (!this.generatePwItem) return false;
      this.table.loading = true;
      this.$store
        .dispatch('User/generatePassword', this.generatePwItem)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.generatePwItem = null;
          this.getData();
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.table.loading = false));
      this.dialogGenerate = false;
    },
    goToCreate() {
      this.$router.push({ name: 'MasterUserCreate' });
    }
  },
  created() {
    this.$store.commit('table/RESET_PAGEABLE');
    this.getRole();
    this.getData();
  },
  submit() {
    this.$v.$touch();
    if (this.$v.$invalid) {
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
